<template>
  <div class="object-templates">
    <object-templates-attributes
      maxWidth="1000px"
      maxHeight="100vh"
      :show="appended"
      :loading="loading"
      :title="objectTypeName"
      :systems="systems"
      :attributes="attributes"
      :attributeTypes="attributeTypes"
      :references="references"
      @close="hideAppendNew"
      @add="addNewAttribute"
    ></object-templates-attributes>

    <h3>{{ $t("object_templates_title") }}</h3>

    <div>
      <label class="app__label" for="object-templates__type-id">
        {{ $t("object_templates_object_types") }}
      </label>
      <el-select
        id="object-templates__type-id"
        v-model="objectTypesId"
        filterable
        @change="objectTypesChange"
      >
        <el-option
          v-for="item in objectTypesList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>

    <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">
      <el-table-column type="index" width="50"></el-table-column>

      <el-table-column
        prop="name"
        :label="$t('object_templates_table_name')"
      ></el-table-column>

      <el-table-column
        prop="attribute"
        :label="$t('object_templates_table_type')"
      >
        <template slot-scope="scope">
          {{ getAttributeName(scope.row.attribute.attributeType) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="numberInOrder"
        width="150"
        :label="$t('object_templates_table_order')"
      >
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.numberInOrder"
            @change="changeSystems(scope.row.id)"
          ></el-input-number>
        </template>
      </el-table-column>

      <el-table-column
        prop="required"
        width="100"
        align="center"
        :label="$t('object_templates_table_required')"
      >
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.required"
            @change="changeSystems(scope.row.id)"
          ></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column
        prop="used"
        width="250"
        :label="$t('object_templates_table_system')"
      >
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.used"
            multiple
            @change="changeSystems(scope.row.id)"
          >
            <el-option
              v-for="item in systems"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column width="70">
        <template slot-scope="scope">
          <el-button
            type="warning"
            icon="el-icon-delete"
            :title="$t('object_templates_table_delete_title')"
            @click="deleteItem(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="object-templates__actions">
      <el-button
        class="object-templates__actions_item"
        type="primary"
        :disabled="!objectTypesId"
        @click="appendNew"
      >
        {{ $t("object_templates_add") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import ObjectTemplatesAttributes from "./object-templates__attributes/ObjectTemplatesAttributes.vue";

import * as service from "@/domain/settings/objectTemplates.service";

import { CREATE, READ, UPDATE, DELETE } from "@/domain/crud.types";

import { Attribute } from "@/mixins";

export default {
  name: "ObjectTemplates",
  components: {
    ObjectTemplatesAttributes
  },
  props: {
    items: Array,
    objectTypes: Array,
    attributeTemplates: Array,
    languages: Array,
    attributeTypes: Array,
    references: Array,
    systems: Array,
    loading: Boolean
  },
  mixins: [Attribute],
  data() {
    return {
      objectTypesId: undefined,
      appended: false,
      lastAction: undefined
    };
  },
  computed: {
    defaultLangId() {
      let lang = this.languages.find(lang => lang.default);
      if (lang) {
        return lang.id;
      }
      return false;
    },
    tableData() {
      if (this.items && this.items.length > 0) {
        return service.getTableData(this.items, this.defaultLangId);
      }
      return [];
    },
    objectTypesList() {
      return service.getUsedTypes(this.objectTypes);
    },
    objectTypeName() {
      if (this.objectTypesId) {
        let item = this.objectTypesList.find(o => o.id === this.objectTypesId);
        if (item) {
          return item.name;
        }
      }
      return "";
    },
    attributes() {
      return service.getAttributes(
        this.items,
        this.attributeTemplates,
        this.defaultLangId
      );
    }
  },
  methods: {
    objectTypesChange() {
      if (this.objectTypesId) {
        this.lastAction = READ;
        this.$emit("read", { objectTypesId: this.objectTypesId });
      }
    },
    changeSystems(id) {
      this.lastAction = UPDATE;
      this.$emit(
        "update",
        service.prepareToUpdate(this.objectTypesId, this.tableData, id)
      );
    },
    appendNew() {
      this.appended = true;
    },
    hideAppendNew() {
      this.appended = false;
    },
    addNewAttribute(id) {
      this.lastAction = CREATE;
      this.$emit(
        "create",
        service.prepareToSave(this.objectTypesId, this.attributes, id)
      );
    },
    deleteItem(id) {
      this.lastAction = DELETE;
      this.$emit("delete", { id, objectTypesId: this.objectTypesId });
    }
  },
  watch: {
    loading: function (val) {
      if (val === false && this.lastAction && this.lastAction !== READ) {
        this.objectTypesChange();
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.object-templates {
  width: 100%;
  height: 100%;
  position: relative;

  .object-templates__actions {
    position: sticky;
    bottom: -5px;
    margin-top: 10px;
    padding: 10px 0;
    text-align: right;
    width: 100%;
    background-color: $free_zone_color;
    z-index: 3;

    .object-templates__actions_item {
      margin: 0 10px;
    }
  }
}
</style>
